import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexElement } from '../Flex/index.js';

export type SpinnerElement = FlexElement;

export const Spinner = styled(Flex)`
  width: 65px;
  aspect-ratio: 1;
  position: relative;
  scale: 0.5;

  &:before,
  &:after {
    content: '';
    position: absolute;
    border-radius: 50px;
    box-shadow: 0 0 0 6px inset var(--spz-sys-color-on-surface);
    animation: sc5 2.5s infinite;
  }
  &:after {
    animation-delay: -1.25s;
    border-radius: 0;
  }
  @keyframes sc5 {
    0% {
      inset: 0 35px 35px 0;
    }
    12.5% {
      inset: 0 35px 0 0;
    }
    25% {
      inset: 35px 35px 0 0;
    }
    37.5% {
      inset: 35px 0 0 0;
    }
    50% {
      inset: 35px 0 0 35px;
    }
    62.5% {
      inset: 0 0 0 35px;
    }
    75% {
      inset: 0 0 35px 35px;
    }
    87.5% {
      inset: 0 0 35px 0;
    }
    100% {
      inset: 0 35px 35px 0;
    }
  }
`;
